import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus, DollarSign, Clock, Package } from 'lucide-react';

interface StaffActionCardsProps {
  onNewOrder?: () => void;
  onPriceCheck?: () => void;
  onEmployeeClockIn?: () => void;
  onViewAllScannedItems?: () => void;
}

export const StaffActionCards = ({
  onNewOrder,
  onPriceCheck,
  onEmployeeClockIn,
  onViewAllScannedItems,
}: StaffActionCardsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <Card className="hover:shadow-md transition-shadow">
        <CardContent className="p-6">
          <div className="flex items-center space-x-4">
            <div className="bg-blue-100 p-3 rounded-full">
              <Plus className="h-6 w-6 text-blue-600" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900">New Order</h3>
              <p className="text-sm text-gray-600 mb-3">Start checking in a new delivery</p>
              <Button onClick={onNewOrder} className="w-full">
                Create Order
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="hover:shadow-md transition-shadow">
        <CardContent className="p-6">
          <div className="flex items-center space-x-4">
            <div className="bg-green-100 p-3 rounded-full">
              <DollarSign className="h-6 w-6 text-green-600" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900">Price Check</h3>
              <p className="text-sm text-gray-600 mb-3">Look up product prices quickly</p>
              <Button onClick={onPriceCheck} variant="outline" className="w-full">
                Check Prices
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="hover:shadow-md transition-shadow">
        <CardContent className="p-6">
          <div className="flex items-center space-x-4">
            <div className="bg-purple-100 p-3 rounded-full">
              <Clock className="h-6 w-6 text-purple-600" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900">Employee Clock In</h3>
              <p className="text-sm text-gray-600 mb-3">Manage employee time tracking</p>
              <Button onClick={onEmployeeClockIn} variant="outline" className="w-full">
                Clock In/Out
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="hover:shadow-md transition-shadow">
        <CardContent className="p-6">
          <div className="flex items-center space-x-4">
            <div className="bg-orange-100 p-3 rounded-full">
              <Package className="h-6 w-6 text-orange-600" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900">All Scanned Items</h3>
              <p className="text-sm text-gray-600 mb-3">View all your scanned products</p>
              <Button onClick={onViewAllScannedItems} variant="outline" className="w-full">
                View Items
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};